import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./home/home.routes').then((m) => m.HOME_ROUTES),
        canActivate: [MsalGuard]
    },
    {
        path: 'work-simulations',
        loadChildren: () => import('./work-simulations/work-simulations.routes').then((m) => m.WORK_SIMULATIONS_ROUTES),
        canActivate: [MsalGuard]
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.routes)
    }
];
